export default "__VITE_ASSET__$G0gwnHL__"